import {useEffect, useRef} from 'react'

import {useInlineCommentDialogModeContext} from '../contexts/InlineCommentDialogModeContext'
import type {DiffAnnotation} from '../types'
import {hideInteractiveElements, showInteractiveElements} from '../util/hide-show-interactive-elements'
import {Annotation} from './Annotation'

interface InlineAnnotationProps {
  annotation: DiffAnnotation
}

/**
 * Inline wrapper for the Annotation component
 * Used within inline markers to display annotations in the context of code
 */
export function InlineAnnotation({annotation}: InlineAnnotationProps) {
  const annotationRef = useRef<HTMLDivElement>(null)
  const {isInDialogMode} = useInlineCommentDialogModeContext()

  useEffect(() => {
    if (!isInDialogMode) {
      hideInteractiveElements(annotationRef.current)
    } else {
      showInteractiveElements(annotationRef.current)
    }
  }, [isInDialogMode])

  return (
    <div ref={annotationRef}>
      <Annotation annotation={annotation} />
    </div>
  )
}

try{ InlineAnnotation.displayName ||= 'InlineAnnotation' } catch {}